import { useState, useRef, useEffect, useMemo } from "react";

//scss
import "./style.scss";

//assets
import { SvgCross } from "assets/icons/js/SvgCross";

//hooks
import { useOnClickOutside } from "customHooks/useOnClickOutside";
import { useMediaQuery } from "customHooks/useMediaQuery";

//helpers
import compareStrings from "helpers/compareString";

//components
import Modal from "components/LoginAndRegister/Modal";
import Input from "components/ListingNew/ListingNormal/Faqs/GreyInputBox";
import Faq from "../Faq";

const AllFAQs = (
	{ faqData, open, setOpen, query = "", setQuery, theme = {} },
	...props
) => {
	// const width = useMediaQuery();
	const parsedFaqs = useMemo(() => parseFaq(faqData));

	//for closing popup on outside click
	const popupRef = useRef(null);
	useOnClickOutside(popupRef, () => setOpen(false));

	//setting state to show 'no results found'
	const [noFaqs, setNoFaq] = useState(true);
	useEffect(() => {
		setNoFaq(() => showNoFaqFound(parsedFaqs, query));
	}, [query]);

	return (
		<div className="all-faqs__wrapper">
			<Modal shouldShow={open} onClose={() => setOpen(false)}>
				<div
					className="all-faqs"
					ref={popupRef}
					style={{ background: theme.background }}
				>
					<h3
						className="all-faqs__header"
						style={{
							background: theme.background,
							color: theme.primaryTextColor,
						}}
					>
						<span>FAQs</span>
						<SvgCross id="all-faqs__cross" onClick={() => setOpen(false)} />
					</h3>
					<div
						className="all-faqs__body"
						style={{ background: theme.background }}
					>
						<Input
							id="all-faqs__input"
							value={query}
							onChange={setQuery}
							placeholder="Search your questions"
							className="all-faqs__search"
							timeout={300}
							autoFocus={false}
						/>
						{noFaqs && (
							<div
								className="all-faqs__no-result text-xsm-bold "
								style={{ color: theme.primaryTextColor }}
							>
								<i>There is no result for "{query}"</i>
							</div>
						)}
						<div className="all-faqs__faqs">
							{parsedFaqs.map((object, index) => {
								return (
									<FaqSection
										{...object}
										key={index}
										query={query}
										theme={theme}
									/>
								);
							})}
						</div>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default AllFAQs;

//faqs are devided into different categories, this represents those sections
const FaqSection = ({ category, content, query, index, theme }) => {
	const checkFaqFound = () => {
		let flag = false;
		content.forEach((faq) => {
			if (
				showFaq({
					ques: faq.question_test,
					ans: faq.question_answer,
					query,
				})
			) {
				flag = true;
			}
		});
		return flag;
	};

	//this is required because we have to hide the name of the category as well if we are not showing any faq under that category
	const [showHeading, setShowHeading] = useState(() => checkFaqFound());
	useEffect(() => {
		setShowHeading(() => checkFaqFound());
	}, [query]);

	return (
		<div className="faq-popup-section" index={index}>
			{showHeading && (
				<h3
					style={{
						color: theme.primaryTextColor,
					}}
				>
					{category}
				</h3>
			)}
			{content.map((faq, index) => {
				if (
					showFaq({
						ques: faq.question_test,
						ans: faq.question_answer,
						query,
					})
				) {
					return <Faq {...faq} key={index} query={query} theme={theme} />;
				}
				return null;
			})}
		</div>
	);
};

/*parse faq object in the form : 
faqs=[{
  category:string,
  content=[],
}]*/
const parseFaq = (faqData) => {
	let faqs = [];
	try {
		Object.entries(faqData).forEach(([key, value]) => {
			faqs.push({
				category: key,
				content: value,
			});
		});
	} catch (e) {}
	return faqs;
};

//whether to show the faq or not
const showFaq = ({ ans, ques, query }) => {
	if (compareStrings(ans, query) || compareStrings(ques, query) || query === "")
		return true;
	else return false;
};

//determining when to show 'no results'
const showNoFaqFound = (parsedFaqs, query) => {
	let flag = true;
	parsedFaqs.forEach((object) => {
		object.content.forEach((faq) => {
			if (
				showFaq({
					ques: faq.question_test,
					ans: faq.question_answer,
					query,
				})
			) {
				flag = false;
			}
		});
	});
	return flag;
};
